jQuery(document).ready(function ($) {
    'use strict';

    $(document.body).on('click', '.search-open', function() {

        $('.header-search').show();
        $(this).hide();

    });

    $(document.body).on('click', '.search-close', function() {

        $('.header-search').hide();
        $('.search-open').css('display', 'flex');

    });

});